export * from './sence'
export * from './external'
export type Sence = 0
export type Zoom = 1
export type Coursera = 2
export type Udemy = 3

export type AllIntegrationTypes = Sence | Zoom | Coursera

const sence: Sence = 0
const zoom: Zoom = 1
const coursera: Coursera = 2

export const IntegrationTypes = {
  sence,
  zoom,
  coursera,
}

export const integrationTypesByKeys = Object.keys(IntegrationTypes).reduce(
  (acc, key) => {
    acc[IntegrationTypes[key]] = key
    return acc
  },
  {} as Record<AllIntegrationTypes, string>
)

interface IntegrationBase {
  id: number
  active: boolean
}

export interface SessionSence {
  id: number
  userId: number
  sessionSence: string
  senceCode: string
  active: boolean
  startDate: Date
  timezone: string
  deletedAt: null
  createdAt: Date
  updatedAt: Date
}

export interface IntegrationConfigSence {
  token?: string | null
  runOtec?: string | null
  session?: SessionSence | null
}

export interface IntegrationConfigZoom {
  accountId?: string | null
  clientId?: string | null
  clientSecret?: string | null
}

export interface IntegrationConfigCoursera {
  orgId?: string | null
  appKey?: string | null
  appSecret?: string | null
}

export interface IntegrationConfigUdemy {
  orgId?: string | null
  appKey?: string | null
  appSecret?: string | null
}

export interface IntegrationSence extends IntegrationBase {
  config?: IntegrationConfigSence | null
  integrationType: Sence
}

export interface IntegrationZoom extends IntegrationBase {
  config?: IntegrationConfigZoom | null
  integrationType: Zoom
}

export interface IntegrationCoursera extends IntegrationBase {
  config?: IntegrationConfigCoursera | null
  integrationType: Coursera
}

export interface IntegrationUdemy extends IntegrationBase {
  config?: IntegrationConfigUdemy | null
  integrationType: Udemy
}

export type Integration =
  | IntegrationSence
  | IntegrationZoom
  | IntegrationCoursera
  | IntegrationUdemy

type Upsert<T extends Integration> = Omit<T, 'id'>

export type UpsertIntegrationSence = Upsert<IntegrationSence>
export type UpsertIntegrationZoom = Upsert<IntegrationZoom>
export type UpsertIntegrationCoursera = Upsert<IntegrationCoursera>

export type IntegrationUpsert =
  | UpsertIntegrationSence
  | UpsertIntegrationZoom
  | UpsertIntegrationCoursera
